import { css } from "styled-components";
import { theme } from "../theme";

export const CheckStyle = css`
  appearance: none;

  &:after {
    content: "";
    position: relative;
    display: block;
    top: -25%;
    width: 20px;
    height: 20px;

    border: 1px solid #c4c4c4;
    border-radius: 50%;
    background: ${theme.colors.white};
  }

  &:checked:after {
    background: ${theme.colors.green1};
    border: 3px solid ${theme.colors.white};
    box-shadow: 0px 0px 0px 2px ${theme.colors.green1};
  }

  &:checked ~ span {
    font-weight: ${theme.font.bold};
  }
`;
